// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Link from "./Link.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function NavLink(Props) {
  let route = Props.route;
  let activeRoute = Props.activeRoute;
  let currentRoute = Props.currentRoute;
  let isActiveRoute = Props.isActiveRoute;
  let className = Props.className;
  let activeClassName = Props.activeClassName;
  let eventNameOpt = Props.eventName;
  let children = Props.children;
  let onCloseOpt = Props.onClose;
  let bar = Props.bar;
  let setBar = Props.setBar;
  let onMouseEnterOpt = Props.onMouseEnter;
  let onMouseLeaveOpt = Props.onMouseLeave;
  const eventName = eventNameOpt !== undefined ? eventNameOpt : "";
  const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
      
    });
  const onMouseEnter = onMouseEnterOpt !== undefined ? onMouseEnterOpt : (function (param) {
      
    });
  const onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : (function (param) {
      
    });
  const jitsu = JitsuReact.useJitsu();
  const activeRoute$1 = Belt__Belt_Option.getWithDefault(activeRoute, route);
  const currentRoute$1 = Belt__Belt_Option.getWithDefault(currentRoute, /* OrgChoose */ 0);
  const funActiveRoute = Belt__Belt_Option.getWithDefault(isActiveRoute, (function (current) {
    return Caml_obj.caml_equal(activeRoute$1, current);
  }));
  const trackEvent = function (param) {
    if (eventName === "") {
      return;
    } else {
      return Curry._1(jitsu.analytics.track, eventName);
    }
  };
  const className$1 = Cn.fromList({
    hd: Cn.on(Cn.take(className), !Curry._1(funActiveRoute, currentRoute$1)),
    tl: {
      hd: Cn.on(Cn.take(activeClassName), Curry._1(funActiveRoute, currentRoute$1)),
      tl: /* [] */ 0
    }
  });
  return JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: route,
    className: className$1,
    onLinkClicked: (function (param) {
      trackEvent(undefined);
      Curry._1(onClose, undefined);
      Curry._1(setBar, (function (param) {
        return bar;
      }));
    }),
    children: children,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
}

const make = NavLink;

export {
  make,
}
/* @jitsu/jitsu-react Not a pure module */
